import { createComponentExtension, createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { changeManagementRouteRef } from './routes';

import { Entity } from '@backstage/catalog-model';

export const changeManagementPlugin = createPlugin({
  id: 'change-management',
  routes: {
    changeManagement: changeManagementRouteRef,
  },
});

export const isChangeManagementRelationAvailable = (entity: Entity) => {
  const dependsOn = (entity?.spec?.dependsOn as []) || [];   
  const predicate = (str:string ): boolean => str.includes('changemanagement');
  return Boolean(dependsOn.find(predicate));
}

export const getChangeManagementName = (entity?: Entity): string => {
  const dependsOnEntities = (entity?.spec?.dependsOn as []) || [];
  const dependsOnCmTuple = dependsOnEntities?.find(findCmDependency) || '';
  return dependsOnCmTuple.slice(dependsOnCmTuple.lastIndexOf(':') + 1);
}

function findCmDependency(dependency: string) {
  return dependency.includes('changemanagement');
}


export const ChangeManagementPage = changeManagementPlugin.provide(
         createRoutableExtension({
           name: 'ChangeManagementPage',
           component: () =>
             import('./components/ChangeManagementPage').then(
               m => m.ChangeManagementPage,
             ),
           mountPoint: changeManagementRouteRef,
         }),
       );

export const ChangeManagementEntityCard = changeManagementPlugin.provide(
  createComponentExtension({
    name: 'ChangeManagementEntityCard',
    component: {
      lazy: () => 
        import('./components/Cards/ChangeManagementEntityCard').then(
          m => m.ChangeManagementEntityCard,
        ),
    }
  }));

export const ChangeManagementEntityAboutCard = changeManagementPlugin.provide(
         createComponentExtension({
           name: 'ChangeManagementEntityAboutCard',
           component: {
             lazy: () =>
               import('./components/Cards/ChangeManagementEntityAboutCard').then(
                 m => m.ChangeManagementEntityAboutCard,
               ),
           },
         }),
       );
